// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { SparkleOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';
import { useAIEditorContext } from '@/components/LyearnAI/components/Editor/context/AIEditorContext';
import GradientText from '@/components/LyearnAI/components/GradientText';
import { useGenerativeTaskContext } from '@/components/LyearnAI/context/generativeTaskContext';

import Typer from '../../../../Typer';
import { AISuggestionContainerProps } from '../../../types';

function AISuggestionContainer({
  className,
  classes,
  headerData,
  showHeader = true,
  showHeaderIcon = false,
  headerTypographyProps,
  bodyTypographyProps,
}: AISuggestionContainerProps) {
  const { isTyping } = useGenerativeTaskContext();
  const { showSuggestions, suggestedText, lastTransformation } = useAIEditorContext();
  const { t } = useTranslation();

  if (!showSuggestions) {
    return null;
  }

  const header = headerData && lastTransformation ? headerData[lastTransformation] : undefined;

  return (
    <Box className={cn('w-auto', className)}>
      {showHeader ? (
        <GradientText
          Icon={header?.Icon ?? SparkleOutline}
          classes={classes?.header}
          showIcon={showHeaderIcon}
          text={header?.label ?? t('AI:LyearnAISuggestions')}
          variant={headerTypographyProps?.variant ?? 'label-01'}
        />
      ) : null}
      <Typography
        className={cn('inline whitespace-pre-wrap', classes?.body)}
        color={bodyTypographyProps?.color ?? 'text-text-paragraph'}
        variant={bodyTypographyProps?.variant ?? 'body-short-01'}>
        {suggestedText}
        {isTyping ? <Typer /> : null}
      </Typography>
    </Box>
  );
}

export default AISuggestionContainer;
